import TablePage from '@/found/components/table_page';
import Form from './components/index';

export default {
  extends: TablePage,
  name: 'main_list',
  data() {
    return {
      requestType: 'POST',
    };
  },
  components: {
    Form,
  },
  created() {
    this.getConfigList('main_list');
  },

  methods: {
    clickVisible({ val, row }) {
      if (val.code === 'add_tack_order') {
        return !row.logisticsTrackingNumber;
      }
      return true;
    },
    modalClick({ val, row }) {
      console.log(val);
      const { code } = val;
      if (code === 'add_tack_order') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name;
        this.modalConfig.width = '500px';
        this.openModal();
      }
    },
  },
};
